import {PasswordReset} from '@/hooks/api/models';
import axios from '@/lib/axios';
import {useMutation} from '@tanstack/react-query';

type Props = {
  email: string;
}

const createPasswordReset = (props: Props): Promise<PasswordReset> => {
  return axios.post(`/api/user_password_resets`, props);
};

export const useCreatePasswordReset = () => {
  return useMutation({
    mutationFn: createPasswordReset
  });
};
